import { Fragment } from 'react';
import { BetaBadge } from '@/shared/components/Badge/BetaBadge';
import { BetaChip } from '@/shared/components/Chip/BetaChip';
import { cn } from '@/utils/tailwind.util';
export const AiButtonIcon = ({
  icon,
  className
}: {
  icon: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('rounded-[10px] bg-violet-50 p-xs size-fit', className)} data-sentry-component="AiButtonIcon" data-sentry-source-file="AiButtonBase.tsx">
      {icon}
    </div>;
};
export const AiButton = ({
  onClick,
  icon,
  label,
  description,
  size,
  isBeta = false
}: {
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  description: string;
  size: 'full' | 'simple';
  isBeta?: boolean;
}) => {
  return <div role="button" className={cn('relative flex min-w-0 flex-1 cursor-pointer flex-row gap-sm rounded-md border border-assistive bg-default p-sm shadow-xs', size === 'full' && 'items-start tablet-sm:p-md', size === 'simple' && 'items-center')} onClick={onClick} data-sentry-component="AiButton" data-sentry-source-file="AiButtonBase.tsx">
      {icon}
      {isBeta && <Fragment>
          <BetaChip size="sm" variant="outlined" className={cn('absolute right-md top-md border-yellow-600 text-yellow-900', size === 'simple' && 'hidden')} />
        </Fragment>}
      <div className={cn('relative flex min-w-0 items-center', size === 'full' && 'flex flex-1 flex-col gap-4xs items-start', size === 'simple' && 'gap-2xs')}>
        <span className="truncate text-body-md-semibold text-default">
          {label}
        </span>
        {size === 'simple' && isBeta && <BetaBadge />}
        {size === 'full' && <span className="line-clamp-2 text-caption-md-medium text-assistive [overflow-wrap:anywhere]">
            {description}
          </span>}
      </div>
    </div>;
};